import React from 'react';

export default function TikTokIcon({ size = 16, color = "currentColor", style = {}, className = "" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={color}
            className={`tiktok-svg-icon ${className}`}
            style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                ...style
            }}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.298-.002.595.042.88.13V9.4a6.33 6.33 0 0 0-1-.08A6.34 6.34 0 0 0 3 15.66a6.34 6.34 0 0 0 10.82 4.5 6.27 6.27 0 0 0 1.96-4.49V8.71a8.21 8.21 0 0 0 4.81 1.48v-3.5z" />
        </svg>
    );
}
